module.exports = __webpack_public_path__ + "img/building-line-trans.5669e3e5.svg";